import clsx from 'clsx';
import React from 'react';

interface LabeledDropdownProps {
  id: string;
  label: string;
  value: string;
  options: Array<{ value: string; label: string }>;
  onChange?: (value: string) => void;
  className?: string;
  labelClassName?: string;
  selectClassName?: string;
}

const LabeledDropdown: React.FC<LabeledDropdownProps> = ({
  id,
  label,
  value,
  options,
  onChange,
  className = '',
  labelClassName = '',
  selectClassName = '',
}) => {
  return (
    <div className={clsx('flex flex-col',className)}>
      <label 
        htmlFor={id} 
        className={clsx("block mb-2 text-sm font-medium text-gray-700",labelClassName)}
      >
        {label}
      </label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        className={clsx(
          "h-10 border border-gray-300 text-gray-700 text-sm rounded-md block w-full py-2 px-3 focus:outline-none focus:border-gray-300 bg-white appearance-none cursor-pointer hover:bg-gray-50 transition-colors",
          selectClassName
        )}
        style={{
          backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e")`,
          backgroundPosition: 'right 0.5rem center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: '1.5em 1.5em',
          paddingRight: '2.5rem',
        }}
      >
        {options.map((option,index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default LabeledDropdown;
